import NoSearchResults from './NoSearchResults';

export default NoSearchResults;
